import { FC, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from 'src/components/common/Typography';
import { FooterContext } from 'src/constructors/Footer/FooterConstructor';
import { reachTextParser, setBodyOverflow } from 'src/helpers/utils';
import { useConnectedAction } from 'src/hooks/use-connected-action';
import { openMyAccountModal } from 'src/store/account-modal/actions';
import './styles.scss';

type Props = {
  settings: {
    priority: number;
    styles: Styles;
  };
};
const TermsBriefInfo: FC<Props> = ({ settings }) => {
  const { styles } = settings;
  const footerConfigs = useContext(FooterContext);
  const { t }: Translation = useTranslation();
  const _openAccountModal = useConnectedAction(openMyAccountModal);

  const openTermsAndConditions = (): void => {
    setBodyOverflow('unset');
    _openAccountModal({
      section: 'info_and_rules',
      subSection: 'termsConditions',
      subTitle: t('terms_and_conditions'),
    });
  };

  useEffect(() => {
    footerConfigs?.content?.websiteTermsBriefInfo &&
      document.getElementById('terms_and_conditions')?.addEventListener('click', openTermsAndConditions);
  }, [footerConfigs?.content?.websiteTermsBriefInfo]);

  return (
    <Typography className="activity_info_wrapper" variant={'h6'} style={styles}>
      {(footerConfigs?.content?.websiteTermsBriefInfo &&
        reachTextParser(footerConfigs?.content?.websiteTermsBriefInfo)) ||
        'WEBSITE_TERMS_BRIEF_INFO'}
    </Typography>
  );
};
export default TermsBriefInfo;
